import { useSaveRequestAndGoToNextStep } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { trackOpenWithFaireOwfSignUpFlowUpsellSkipClick } from "@faire/web-api--source/events/openWithFaire/click/owfSignUpFlowUpsellSkip";
import { trackSignupSignupSkipCtaClickActionCategoryClick } from "@faire/web-api--source/events/signup/actionCategoryClick/signupSkipCtaClick";
import { route as openWithFaireApplicationRoute } from "@faire/web-api--source/routes/www/welcome/r/open-with-faire/application";
import { route as openWithFaireIntroRoute } from "@faire/web-api--source/routes/www/welcome/r/open-with-faire/intro";
import { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";
import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

const OwFIntroStepRouteMatcher = new RouteMatcher<RetailerRoute>([
  openWithFaireIntroRoute,
]);

const OwFApplicationStepRouteMatcher = new RouteMatcher<RetailerRoute>([
  openWithFaireApplicationRoute,
]);

export const useHandleOwFSkip = () => {
  const location = useLocation();
  const { saveAndGoToNextStep: introStepSaveAndGoToNextStep } =
    useSaveRequestAndGoToNextStep(Step.OWF_UPSELL, true);
  const { saveAndGoToNextStep: applicationStepSaveAndGoToNextStep } =
    useSaveRequestAndGoToNextStep(Step.OWF_APPLICATION, true);
  const handleOwFIntroSkip = useCallback(() => {
    trackOpenWithFaireOwfSignUpFlowUpsellSkipClick();
    introStepSaveAndGoToNextStep(undefined, { skipOwF: true });
  }, [introStepSaveAndGoToNextStep]);
  const handleOwFApplicationSkip = useCallback(() => {
    trackSignupSignupSkipCtaClickActionCategoryClick();
    applicationStepSaveAndGoToNextStep(undefined, { skipOwF: true });
  }, [applicationStepSaveAndGoToNextStep]);

  if (OwFIntroStepRouteMatcher.match(location)) {
    return handleOwFIntroSkip;
  }

  if (OwFApplicationStepRouteMatcher.match(location)) {
    return handleOwFApplicationSkip;
  }

  return () => {};
};
